export const services = [
  {
    icon: "ri-truck-line",
    title: "不用品回収",
    subtitle: "少量から一軒家まで",
    text: "家具・家電・生活用品・衣類・寝具・タンス・ソファなど、家庭内の不用品全般に対応します。1点の少量から、引っ越し・空き家・一軒家のまとまった片付けまでご相談いただけます。",
    points: ["家具・家電・タンス・ソファなど", "少量プランからまとめてまで", "搬出・分別までおまかせ"],
  },
  {
    icon: "ri-heart-2-line",
    title: "遺品整理",
    subtitle: "ご遺族に寄り添って",
    text: "ご遺族のお気持ちに配慮しながら、必要な物と不要な物を確認して整理を進めます。仕分け・搬出・片付けまでまとめて対応します。マンション・アパート・戸建・空き家まで幅広く対応予定です。",
    points: ["マンション・戸建・空き家に対応", "仕分け・搬出・片付けを一括", "必要な物を確認しながら進行"],
  },
  {
    icon: "ri-user-heart-line",
    title: "生前整理",
    subtitle: "元気なうちに身軽に",
    text: "元気なうちに身の回りを整理し、これからの暮らしを身軽にするお手伝いをします。将来ご家族の負担を減らしたい方のご相談も承ります。",
    points: ["身の回りの整理", "将来の負担を軽減", "ご家族と一緒にご相談"],
  },
  {
    icon: "ri-home-4-line",
    title: "空き家整理",
    subtitle: "残置物から修繕まで",
    text: "空き家の中の残置物の整理・搬出に対応します。片付けたあとに傷んでいる箇所があれば、そのまま修繕やリフォームのご相談もいただけます。",
    points: ["残置物の整理・搬出", "片付け後の修繕も相談可", "遠方のご家族のご依頼も"],
  },
  {
    icon: "ri-route-line",
    title: "引っ越し前後の片付け",
    subtitle: "退去・原状回復まで",
    text: "引っ越しや退去に伴う不用品の処分に対応します。退去前の原状回復までまとめてご相談いただけるので、業者を何社も探す手間がありません。",
    points: ["引っ越し前の不用品処分", "退去前の原状回復", "時間がない方もご相談を"],
  },
  {
    icon: "ri-box-3-line",
    title: "その他の片付け",
    subtitle: "まずはご相談ください",
    text: "物が多い住宅の片付け、倉庫・物置の整理、賃貸の残置物、一軒家丸ごとの片付けなども承ります。その他の案件もまずはご相談ください。",
    points: ["倉庫・物置の片付け", "物が多い住宅の整理", "対応可否からご相談"],
  },
];